import React from 'react';

const NotFound: React.FC<{}> = () => {
    return <div>Not found</div>;
};

export default NotFound;
